import moment from 'moment';
import toNumber from 'lodash/toNumber';
import toString from 'lodash/toString';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import toUpper from 'lodash/toUpper';

export const tryGet = (data, indexes) => {
  try {
    return reduce(indexes, (acc, e) => acc[e], data) || '-';
  } catch (e) {
    return '-';
  }
};

export const toCalendar = timestamp => `${moment(toNumber(timestamp)).format('L')}, ${moment(toNumber(timestamp)).format('LT')}`;

const toCents = value => value ? (toNumber(value)/ 100).toFixed(2) : 0.00;

export const toPriceStr = value => {
  const valueStr = toString(value);
  return `R$ ${valueStr.substring(0, valueStr.length - 2)},${valueStr.substring(valueStr.length - 2, valueStr.length)}`
};

export const translateStatus = status => ({
  done: 'Terminado',
  waiting: 'Aguardando',
  pending: 'Pendente',
  enrolled: 'Em Andamento',
  event: 'Evento',
  ok: 'ok'
}[status]);

export const translateVehicle = vehicleId =>
  vehicleId === 'none'
  ? '-'
  : vehicleId;

export const translateFinalSlot = finalSlot =>
  finalSlot ? 'Sim' : 'Não';

export const concatSlotId = slotIds => toString(map(slotIds, el => el._id)).replace(/,/g, ', ');

export const translateEvent = event => {
  switch (event) {
    case 'paused': return 'Sistema - Pausado';
    case 'choose': return 'Sistema - Pré Cargas Delegadas';
    case 'unavailable': return 'Sistema - Veículo Indisponível';
    case 'updateDelivery': return 'Sistema - Pré Carga Atualizada';
    case 'deleteDelivery': return 'Sistema - Pré Carga Removida';
    case 'updateMeta': return 'Sistema - Veículo Atualizado';
    case 'updateSlot': return 'Sistema - Peso Atualizado';
    case 'deleteSlot': return 'Sistema - Peso Removido';
    case 'deleteUser': return 'Sistema - Usuário Removido';
    case 'deleteMeta': return 'Sistema - Veículo Removido';
    default: return event;
  }
};

export const makeTableData = data => map(data,
  ({
    timestamp,
    value,
    status,
    finalSlot,
    vehicleId,
    vehicleValue,
    slotType,
    validFrom,
    event,
    ...rest
  }) => ({
    timestamp,
    validFrom,
    calendarT: toCalendar(timestamp),
    updateT: toCalendar(validFrom),
    value,
    valueT: toCents(value),
    vehicleValue,
    vehicleValueT: toCents(vehicleValue),
    finalSlot,
    finalSlotT: translateFinalSlot(finalSlot),
    status,
    statusT: translateStatus(status),
    vehicleId,
    vehicleIdT: translateVehicle(vehicleId),
    slotType,
    slotTypeT: toUpper(slotType),
    event,
    eventT: translateEvent(event),
    ...rest
  })
);
